import { useMutation } from '@zg-rentals/react-query5';
import { listing, type ReportListingBody } from '@/src/lib/api/endpoints/listing';

/**
 * Submits a listing report (PUT /v2/listing/report). Mirrors legacy
 * hotpads-web's ListingEngineActions.sendReport — body carries the listing
 * `alias`, a `type` reason, and an optional free-text `message`.
 */
export const useReportListing = () => {
  return useMutation({
    mutationFn: (body: ReportListingBody) => listing.reportListing(body),
    meta: {
      context: {
        api: 'hotpads-api',
        details: 'report listing',
      },
    },
  });
};
